import React from 'react'
import { Skeleton } from 'src/component/ui/skeleton'

export const ProfileProgrammeAwardsCardSkeleton = (): React.ReactElement => {
  return <Skeleton className="relative p-[10px] px-5 rounded-md bg-tertiary-grey h-[147px]" />
}
